import { Component, input, OnInit } from '@angular/core';
import { faFire, faChevronRight, faFileLines, faMessage } from '@fortawesome/free-solid-svg-icons';
import { MatTableDataSource } from '@angular/material/table';
import { ReportService } from 'src/app/services/report.service';

@Component({
    selector: 'line-assignments',
    templateUrl: './line-assignments.component.html',
    styleUrls: ['./line-assignments.component.scss'],
    standalone: false
})


export class LineAssignmentsComponent implements OnInit {
  //icons
  faFire = faFire;
  faChevronRight = faChevronRight;
  faFileLines = faFileLines;
  faMessage = faMessage;

  //table variables
  reports = new MatTableDataSource<any>();
  rawReports: any;
  report_count = 0;
  displayedColumns = [
    'name',
    'reportId',
    'action_type',
    'report_type',
    'report_status',
    'auth_status',
    'comments',
    'action'
  ];
  reportCount = 5;

  //dropdown lists
  regions: any;
  statuses: any;
  complexities: any;
  team_leads: any;
  yearsArray: any;

  //access
  user = input.required<any>();

  constructor(
    private readonly reportsService: ReportService,
  ) {
  }

  ngOnInit(): void {
    this.loadReportData();

  }

  loadReportData() {
    let reportRelations = '&relations=users.skills,assessment,comments';
    let authorization_status_id: number | null = null;

    if (this.user().isROLO) {
      authorization_status_id = 1;	//ROLO Signature Requested
    }
    else if (this.user().isFOLO) {
      authorization_status_id = 0;	//FOLO Signature Requested
    } //else is WOLO

    this.reportsService.getReportListByStatus(reportRelations, 2, authorization_status_id).subscribe(
      {
        next: (data) => {
          let reports = this.filterReports(data.reports);
          this.setReportComments(reports);
          reports.sort((reportA: any, reportB: any) => reportB.report_id - reportA.report_id);
          this.rawReports = reports;
          this.report_count = reports.length;
          reports = reports.slice(0, this.reportCount);
          this.reports.data = reports;
        }
      });
  }

  setReportComments(reports: any) {
    reports.forEach((report: any) => {
      let findUnresolved = report.comments.find((x: any) => !x.resolved)
      if (findUnresolved ?? false) report.comments_unresolved = true;
    });
  }

  filterReports(reports: any) {
    if (this.user().isROLO) {
      reports = reports.filter((report: any) => report.region.includes(this.user().isROLO.region));
    }
    else if (this.user().isFOLO) {
      reports = reports.filter((report: any) => report.region.includes(this.user().isFOLO.region));
      reports = reports.filter((report: any) => report.assessment.forest_name.includes(this.user().isFOLO.forest_name));
    }
    return reports;
  }

  loadMore() {
    this.reportCount += 5;
    this.reports.data = this.rawReports.slice(0, this.reportCount);
  }
}